import { Avatar, CardHeader, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { colors } from '../../../../assets/themes/colors.ts';
import { vyPalette } from '../../../../assets/themes/vyPalette.ts';
import { Size, SIZES } from '../../../types/sizes';
import { SIZE_MAP } from './config.ts';

export type DescriptionTitleProps = {
  title: string;
  subTitle?: ReactNode;
  icon?: ReactNode;
  size?: Extract<Size, typeof SIZES.SMALL | typeof SIZES.MEDIUM | typeof SIZES.LARGE>;
  boldTitle?: boolean;
  cardSx?: SxProps<Theme>;
  avatarSx?: SxProps<Theme>;
  disabled?: boolean;
};

export const VyDescriptionTitle: FC<DescriptionTitleProps> = ({
  title,
  subTitle,
  icon,
  cardSx = {},
  avatarSx = {},
  boldTitle = false,
  size = SIZES.MEDIUM,
  disabled = false,
}) => {
  const { titleSize, subtitleSize } = SIZE_MAP[size];

  return (
    <CardHeader
      slotProps={{
        title: {
          sx: {
            fontSize: titleSize,
            color: disabled ? vyPalette.text.secondary : vyPalette.text.primary,
            fontWeight: boldTitle ? 600 : 400,
          },
        },
        subheader: {
          sx: {
            fontSize: subtitleSize,
            color: vyPalette.text.secondary,
          },
        },
      }}
      sx={{
        padding: 0,
        ...cardSx,

        '& .MuiCardHeader-avatar': {
          display: icon ? 'flex' : 'none',
        },
      }}
      avatar={
        <Avatar
          sx={{
            height: 52,
            width: 52,
            backgroundColor: colors.grey[20],
            ...avatarSx,
          }}
          aria-label="icon"
        >
          {icon}
        </Avatar>
      }
      title={title}
      subheader={subTitle}
    />
  );
};
